module.exports = __webpack_public_path__ + "static/media/yc_logo.bef33bb8.png";